import { useEffect, useRef } from 'react';
import ZyfoxWhiteLogo from '../Images/ZyfoxWhiteLogo.png';

const Footer = () => {
  const footerRef = useRef(null);
  const elementsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          elementsRef.current.forEach((el, index) => {
            if (el) {
              setTimeout(() => el.classList.add('footer-animated'), index * 80);
            }
          });
        }
      },
      { threshold: 0.1 }
    );

    if (footerRef.current) observer.observe(footerRef.current);
    return () => observer.disconnect();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer ref={footerRef} className="relative border-t border-white/5 bg-gradient-to-b from-black to-background-dark overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-0 left-1/4 w-64 sm:w-96 h-64 sm:h-96 bg-primary/5 rounded-full blur-[100px]"></div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 py-12 sm:py-16">
        {/* Main Footer Content - 3 columns on desktop, 1 column centered on mobile */}
        <div className="footer-content">
          {/* Column 1: Logo & Description - Always visible */}
          <div ref={(el) => (elementsRef.current[0] = el)} className="footer-element footer-logo-section">
            <img src={ZyfoxWhiteLogo} alt="Zyfox" className="h-10 sm:h-12 mb-4 footer-logo-img" loading="lazy" />
            <p className="text-white/50 text-sm leading-relaxed">
              The ultimate AI creative suite. Generate professional-grade images, videos, visual effects, and 3D models in seconds with cutting-edge artificial intelligence.
            </p>
          </div>

          {/* Column 2: Services - Hidden on mobile */}
          <div ref={(el) => (elementsRef.current[1] = el)} className="footer-element footer-services">
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-white/50">
              <li className="hover:text-primary transition-colors cursor-pointer">AI Image Generation</li>
              <li className="hover:text-primary transition-colors cursor-pointer">AI Video Generation</li>
              <li className="hover:text-primary transition-colors cursor-pointer">AI Visual Effects</li>
              <li className="hover:text-primary transition-colors cursor-pointer">AI 3D Model Generation</li>
            </ul>
          </div>

          {/* Column 3: Contact - Hidden on mobile */}
          <div ref={(el) => (elementsRef.current[2] = el)} className="footer-element footer-contact">
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-sm text-white/50">
              <li className="flex items-center gap-2">
                <span className="material-symbols-outlined text-primary text-sm">mail</span>
                info@zyfox.in
              </li>
              <li className="flex items-center gap-2">
                <span className="material-symbols-outlined text-primary text-sm">phone</span>
                +91 8123838787
              </li>
              <li className="flex items-center gap-2">
                <span className="material-symbols-outlined text-primary text-sm">location_on</span>
                Mangalore, Karnataka
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section - Single line */}
        <div ref={(el) => (elementsRef.current[3] = el)} className="footer-element footer-bottom mt-10">
          <span className="text-xs sm:text-sm text-white/30">© 2026 Zyfox. All rights reserved.</span>
          <span className="text-white/20 mx-2">•</span>
          <span className="text-xs text-white/40 hover:text-primary transition-colors cursor-pointer">Privacy Policy</span>
          <span className="text-white/20 mx-2">•</span>
          <span className="text-xs text-white/40 hover:text-primary transition-colors cursor-pointer">Terms of Service</span>
          <span className="text-white/20 mx-2">•</span>
          <button 
            onClick={scrollToTop}
            className="footer-back-top flex items-center gap-1 text-xs text-white/40 hover:text-primary transition-colors"
          >
            <span className="material-symbols-outlined text-sm">arrow_upward</span>
            Back to Top
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
